import classNames from 'classnames';
import React, { useState } from 'react';
import { twMerge } from 'tailwind-merge';

interface LoadingImageProps {
  src: string;
  className?: string;
}

/**
 * Keeps a placeholder div while image is loading
 * @TODO improve and move to syntax
 */
export const PlaceholderImg: React.FC<LoadingImageProps> = ({ src, className }) => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <>
      {isLoading && <div className={twMerge(className, 'bg-warm-gray-200')} />}
      <img
        className={twMerge(
          classNames(
            {
              'w-0 h-0 absolute': isLoading,
            },
            className,
          ),
        )}
        src={src}
        loading="lazy"
        onLoad={() => setIsLoading(false)}
      />
    </>
  );
};
